import Vue from 'vue'
import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const MODULE_NAME = 'data-collections'

export const createPublicationDataCollectionModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PublicationDataCollectionModal" */
    './components/PublicationDataCollectionModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
